import axios from "axios";
import authenticationService, { showSessionExpiredAlert } from "../services/authentication_service.js";
import { urls } from "../../config.js";
import {
  getLocalAccessToken,
  getLocalRefreshToken,
  removeUser,
} from "../services/local_service.js";

const instance = axios.create({
  baseURL: urls.resourceOwnerUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = getLocalAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (res) => {
    const { data, headers, config } = res;
    const skipStatus = config.skipStatusValidation === true;
    const responseType = config.responseType;
    const contentType = headers["content-type"] ?? "";
    const isBinary =
      responseType === "blob" ||
      responseType === "arraybuffer" ||
      contentType.includes("application/pdf");

    if (skipStatus || isBinary) {
      return res;
    }

    if (data && data.status === "success") {
      return res;
    }

    if (data === undefined || data === null || typeof data !== "object") {
      return res;
    }

    return Promise.reject("failure in status");
  },
  async (err) => {
    const originalConfig = err.config;

    if (err.response && err.response.status === 401) {
      const refreshToken = getLocalRefreshToken();

      if (refreshToken && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const result = await authenticationService.refreshAccessToken();

          if (result !== true) {
            throw result;
          }

          return instance(originalConfig);
        } catch (error) {
          if (showSessionExpiredAlert()) {
            removeUser();
            window.location.href = "/login/developer";
          }

          return Promise.reject(error);
        }
      } else {
        if (showSessionExpiredAlert()) {
          removeUser();
          window.location.href = "/login/developer";
        }

        return Promise.reject(err);
      }
    }

    const message = err.response?.data?.result?.message;
    return Promise.reject(message ?? err);
  }
);

export default instance;